<template>
  <v-container>
    <v-alert v-if="loadError" type="error" prominent>
      Link ungültig oder abgelaufen. Bitte prüfe den Link oder wende dich an die Organisation.
    </v-alert>

    <v-card v-else-if="bulk">
      <v-card-title class="text-h4">Gruppe: {{ bulk.team }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">Bezahlstatus (Gruppe):</v-col>
          <v-col cols="12" sm="6">
            <Paymentstatus :status="bulk.hasPayed"></Paymentstatus>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="mb-2">Alle Startnummern als ZIP (eine PDF pro Person):</div>
            <v-btn outlined color="brown" :href="zipDownloadLink">Startnummern ZIP</v-btn>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <h3 class="mb-2">Teilnehmer*innen</h3>
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Startnummer</th>
              <th>Name</th>
              <th>Bezahlt</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, idx) in bulk.participants" :key="idx">
              <td>
                <v-chip color="brown" outlined small>{{ p.startNumber }}</v-chip>
              </td>
              <td>{{ p.firstName }} {{ p.lastName }}</td>
              <td>
                <Paymentstatus :status="p.hasPayed"></Paymentstatus>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <template v-if="bulk.shirts && bulk.shirts.length">
          <v-divider class="my-4"></v-divider>
          <h3 class="mb-2">Bestellte Shirts ({{ bulk.shirts.length }})</h3>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Modell</th>
                <th>Größe</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in bulk.shirts" :key="s.id">
                <td>{{ s.model }}</td>
                <td>{{ s.size }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import Paymentstatus from "./basic/Paymentstatus";

export default {
  name: "BulkRegistrationSelfService",
  components: { Paymentstatus },
  data: () => ({
    bulk: null,
    loadError: false
  }),
  computed: {
    token() {
      return this.$route.query.token;
    },
    zipDownloadLink() {
      if (!this.token) return "#";
      return `${this.$base_url}/startnumber/bulk/${this.token}`;
    }
  },
  methods: {
    fetchBulk() {
      const t = this.token;
      if (!t || !/^[a-f0-9]{64}$/i.test(t)) {
        this.loadError = true;
        return;
      }
      const url = `${this.$base_url}/bulkregistration/self-service/${t}`;
      axios
        .get(url)
        .then((response) => {
          this.bulk = response.data;
        })
        .catch(() => {
          this.loadError = true;
        });
    }
  },
  mounted() {
    this.fetchBulk();
  }
};
</script>

<style scoped>
</style>
